/*
 * Copyright (c) Nexign, JSC, 2020-2024.
 */
/**
 * Reducer for Banner component
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.0.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { BannerActionsType } from './bannerActions';
import {
    HIDE_ALTERNATIVE_BANNER_ERROR,
    HIDE_BANNER,
    HIDE_BANNER_ERROR,
    HIDE_BANNER_SUCCESSFUL,
    LOAD_BANNER,
    LOAD_BANNER_FAILED,
    LOAD_BANNER_SUCCESSFUL,
    REGISTRATION_ALTERNATIVE_BANNER_FAILURE,
} from './bannerConstants';
import { IBannerItem } from './bannerTypes';

export interface IBannerReducer {
    bannerId?: number;
    banners: IBannerItem[];
    error: string;
    registerError: string;
    totalCount: number;
}

export const initialState: IBannerReducer = {
    banners: [],
    error: '',
    registerError: '',
    totalCount: 0,
};

const bannerReducer: Reducer<IBannerReducer, BannerActionsType> = (state = initialState, action: BannerActionsType) =>
    produce(state, (draft) => {
        switch (action.type) {
            // LOAD BANNERS
            case LOAD_BANNER:
                break;
            case LOAD_BANNER_SUCCESSFUL:
                draft.banners = action.payload.banners;
                draft.totalCount = action.payload.totalCount;
                break;
            case LOAD_BANNER_FAILED:
                draft.error = action.payload.error;
                break;
            // HIDE BANNER CAMPAIGN
            case HIDE_BANNER:
                draft.bannerId = action.payload.id;
                break;
            case HIDE_BANNER_SUCCESSFUL:
                break;
            case HIDE_BANNER_ERROR:
            case HIDE_ALTERNATIVE_BANNER_ERROR:
                draft.error = action.payload.error;
                break;
            case REGISTRATION_ALTERNATIVE_BANNER_FAILURE:
                draft.registerError = action.payload.error;
                break;
            default:
                break;
        }
    });

export default bannerReducer;
